<template>
  <div class="main">
    <div class="banner">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in banners" :key="index">
            <img :src="item.image" :alt="item.title">
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
      </div>
      <div class="swiper-button-prevb"></div><!--左箭头。如果放置在swiper外面，需要自定义样式。-->
      <div class="swiper-button-nextb"></div>
    </div>
    <div class="box1">
      <div class="w1348">
        <div class="w1200">
          <div class="swiper-containera">
            <div class="swiper-wrapper">
              <div class="swiper-slide bounceInUp wow" data-wow-duration="1s" data-wow-delay="1s" v-for="(item,index) in product" :key="index">
                <img :src="item.image" alt="">
                <span>{{item.title}}</span>
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-paginationa"></div>
          </div>
        </div>
        <div class="swiper-button-preva"></div><!--左箭头。如果放置在swiper外面，需要自定义样式。-->
        <div class="swiper-button-nexta"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import Fetch from '../js/ajax'
export default {
  name: 'Index',
  metaInfo () {
    return {
      meta: [{
        name: 'keywords',
        content: '浙江金科日化原料有限公司,氧系漂白助剂过碳酸钠,SPC'
      }]
    }
  },
  data () {
    return {
      banners: [],
      product: []
    }
  },
  mounted () {
  },
  created () {
    const that = this
    // eslint-disable-next-line
    Fetch.post('Api/Banner', {
    }).then((res) => {
      that.banners = res.result
      setTimeout(function () {
        var myswiper = new Swiper('.swiper-container', {// eslint-disable-line no-unused-vars
          effect: 'fade',
          autoplay: {
            disableOnInteraction: false,
            delay: 5000
          },
          loop: true,
          navigation: {
            nextEl: '.swiper-button-nextb',
            prevEl: '.swiper-button-prevb'
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          observer: true,
          observeParents: true
        })
      })
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/home', {
    }).then((res) => {
      that.product = res.result
      setTimeout(function () {
        var myswipera = new Swiper('.swiper-containera', {// eslint-disable-line no-unused-vars
          loop: true,
          slidesPerView: 'auto',
          loopedSlides: 6,
          navigation: {
            nextEl: '.swiper-button-nexta',
            prevEl: '.swiper-button-preva'
          },
          pagination: {
            el: '.swiper-paginationa',
            clickable: true
          }
        })
      }, 200)
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner{
    height: auto;
  }
  .banner .swiper-slide img{
    width: 100%;
    height: auto;
  }
  .effect1 img{
    transform:scale(1.25,1.25) translate(10%,10%);
    transform:scale(1.1,1.1) translate(4.545%,4.545%);
  }
  .leftUp img{
    -webkit-animation-name:leftUp;animation-name:leftUp;
  }
  @-webkit-keyframes leftUp{
    0%{transform:scale(1.1,1.1) translate(4.545%,4.545%); }
    100%{transform:scale(1.1,1.1)  translate(-4.545%,-4.545%);}
  }
  @keyframes leftUp{
    0%{transform:scale(1.1,1.1) translate(4.545%,4.545%);}
    100%{transform:scale(1.1,1.1)  translate(-4.545%,-4.545%);}
  }

  .moveRight img{
    -webkit-animation-name:moveRight;animation-name:moveRight;
  }
  @-webkit-keyframes moveRight{
    0%{transform:scale(1.1,1.1) translate(-4.545%,0); }
    100%{transform:scale(1.1,1.1)  translate(4.545%,0);}
  }
  @keyframes moveRight{
    0%{transform:scale(1.1,1.1) translate(-4.545%,0);}
    100%{transform:scale(1.1,1.1)  translate(4.545%,0);}
  }
  .moveDown img{-webkit-animation-name:moveDown;animation-name:moveDown;}
  @-webkit-keyframes moveDown{
    0%{transform:scale(1.1,1.1) translate(0,-4.545%); }
    100%{transform:scale(1.1,1.1)  translate(0,4.545%);}
  }
  @keyframes moveDown{
    0%{transform:scale(1.1,1.1) translate(0,-4.545%);}
    100%{transform:scale(1.1,1.1)  translate(0,4.545%);}
  }
  .centerBig img{-webkit-animation-name:centerBig;animation-name:centerBig;}
  @-webkit-keyframes centerBig{
    100%{transform:scale(1.1,1.1);}}
  @keyframes centerBig{
    100%{transform:scale(1.1,1.1);}
  }
  .rightDownBig img{-webkit-animation-name:rightDownBig;animation-name:rightDownBig;}
  @-webkit-keyframes rightDownBig{
    100%{transform:scale(1.1,1.1) translate(4%,4%);}
  }
  @keyframes rightDownBig{
    100%{transform:scale(1.1,1.1) translate(4%,4%);}
  }
  .banner .swiper-slide img{
    animation-duration:5s;
    animation-timing-function:linear;
    animation-fill-mode: forwards;
    -webkit-animation-duration:5s;
    -webkit-animation-timing-function:linear;
    -webkit-animation-fill-mode: forwards;
  }
  .box1{
    height: 600px;
    background: url(../assets/box1.png) center 0 no-repeat;
    overflow: hidden;
  }
  .swiper-containera{
    height: 390px;
  }
  .swiper-containera .swiper-slide{
    width: 240px;
    transition:all ease-out .3s 0s;-webkit-transition:all ease-out .3s 0s;-moz-transition:all ease-out .3s 0s;-o-transition:all ease-out .3s 0s;
    height: 390px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding-left: 13px;
    padding-right: 14px;
  }
  .swiper-containera .swiper-slide img{
    transition:all ease-out .3s 0s;-webkit-transition:all ease-out .3s 0s;-moz-transition:all ease-out .3s 0s;-o-transition:all ease-out .3s 0s;
    width: 210px;
    height: auto;
  }
  .swiper-containera .swiper-slide span{
    transition:all ease-out .3s 0s;-webkit-transition:all ease-out .3s 0s;-moz-transition:all ease-out .3s 0s;-o-transition:all ease-out .3s 0s;
    font-size: 16px;
    color: #333333;
    display: block;
    height: 54px;
    line-height: 54px;
  }
  /* .swiper-containera .swiper-slide-active img{
    width: 100%;
  }
  .swiper-containera .swiper-slide-active {
    padding-left: 0;
    padding-right: 0;
  }
  .swiper-containera .swiper-slide-active span{
    color: #E40A20;
    font-weight: bold;
  } */
  .swiper-containera .swiper-slide:hover img{
    width: 100%;
  }
  .swiper-containera .swiper-slide:hover {
    padding-left: 0;
    padding-right: 0;
  }
  .swiper-containera .swiper-slide:hover span{
    color: #E40A20;
    font-weight: bold;
  }
  .w1348{
    width: 1348px;
    margin: 113px auto 0 auto;
    position: relative;
  }
  .swiper-button-nexta{
    width: 20px;
    height: 60px;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -30px;
    background:url(../assets/jiantou.png) 0 0 no-repeat;
    transform: rotate(180deg);
    transform-origin: 50% 50%;
    z-index: 20;
  }
  .swiper-button-nextb{
    width: 20px;
    height: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -30px;
    margin-left: 680px;
    background:url(../assets/jiantou.png) 0 0 no-repeat;
    transform: rotate(180deg);
    transform-origin: 50% 50%;
    z-index: 20;
  }
  .swiper-button-prevb{
    width: 20px;
    height: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -30px;
    margin-left: -700px;
    background:url(../assets/jiantou.png) 0 0 no-repeat;
    z-index: 20;
  }
  .swiper-button-preva{
    width: 20px;
    height: 60px;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -30px;
    background:url(../assets/jiantou.png) 0 0 no-repeat;
    z-index: 20;
  }
  .swiper-button-nexta:hover,.swiper-button-preva:hover,.swiper-button-nextb:hover,.swiper-button-prevb:hover{
    background:url(../assets/jiantouh.png) 0 0 no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue